import Helpers from "../../../helpers/helpers";
import { server } from "../../globalSettings";

export const requestOption = (method, data) => {
    if (data) {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        };
        return requestOptions
    } else {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json' },
        };
        return requestOptions
    }

}

export const requestAuthOption = (method, data) => {
    let isRemember = localStorage.getItem("remember");
    let token = JSON.parse(localStorage.getItem("token"))

    if (data) {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, },
            body: JSON.stringify(data)
        };
        return requestOptions
    } else {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, },
        };
        return requestOptions
    }

}

// api
export const loginApi = async (user) => {
    const request = requestOption("POST", user)
    try {
        const response = await fetch(`${server}otp/login`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        if (data.code === "account_inactive") {
                            reject(["The account is inactive"]);
                        }
                        else {
                            reject(data);
                        }
                    }
                } else {
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
        // if (response.ok) {
        //     const data = await response.json(); // Parse JSON data
        //     if (data.code === "success") {
        //         return data; // Return the data
        //     } else {
        //         apiError("Username and password are invalid. Please enter correct username and password");
        //         return false; // Custom error message
        //     }
        // } else {
        //     throw new Error('Network response was not ok');
        // }
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};

export const requestOTPApi = async (payload) => {
    const request = requestAuthOption("POST", payload);

    try {
        const response = await fetch(`${server}otp/send`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data);
                    }
                } else {
                    reject(["Something wen wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};

export const logoutApi = async (payload) => {
    const request = requestAuthOption("POST");

    try {
        const response = await fetch(`${server}logout`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        if (!payload?.notDirectToLogin) Helpers.routeToLogin();
                        localStorage.removeItem('token');
                        localStorage.removeItem("selected_account_id");
                    } else {
                        reject(["Unable to logout"]);
                        localStorage.removeItem('token');
                        localStorage.removeItem("selected_account_id");
                    }
                } else {
                    reject(["Something wen wrong, please try again later"]);
                    localStorage.removeItem('token');
                    localStorage.removeItem("selected_account_id");
                }
            });
        });
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};

export const verifyAdminApi = async () => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(`${server}verify`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_user") {
                        reject(["Session timeout, please login again."]);
                        Helpers.routeToLogin();
                    } else {
                        Helpers.routeToLogin();
                    }
                } else {
                    reject(["Something went wrong, please try again later"]);
                    Helpers.routeToLogin();
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            Helpers.routeToLogin();
            // setTimeout(function () {
            //     reject(["Network response error, please try again later"]);
            //     // throw error;
            // })
        })

    }
};

export const switchUserApi = async (payload) => {
    const request = requestAuthOption("POST", payload?.data)
    try {
        const response = await fetch(`${server}account/switch`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {

                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_user") {
                        reject(data);
                        if (!payload?.notDirectToLogin) Helpers.routeToLogin();
                    } else {
                        reject(data)
                        if (!payload?.notDirectToLogin) Helpers.routeToLogin();
                    }
                } else {
                    reject(data);
                    if (!payload?.notDirectToLogin) Helpers.routeToLogin();
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {

            if (!payload?.notDirectToLogin) Helpers.routeToLogin();
            reject(["Network response error, please try again later"]);
            // setTimeout(function () {
            //     reject(["Network response error, please try again later"]);
            //     // throw error;
            // })
        })

    }
};